export default {
    colors: {
        black: "#1d1d1d",
        white: "#fff",
        green: "#8dd432",
        purple: "#823ff0",
        red: "#f03f54",
        orange: "#ff8525",
        darkGrey: '#6c6c6c',
        grey: "#b2b2b2",
        lightGrey: "#f2f2f2",
        lightYellow: "#fff8f2",
        lightPurple: "#f9f5fe",
        lightBlue: "#e8f5ff",

        //! Error color
        errorColor: "#FF0000"
    },

    mediaQuery: {
        DesktopSize: "1920px",
        LaptopSize: "1440px",
        TabletSize: "1200px",
        TabletSizeS: "900px",
        MobileSize: "601px",
    }
}